
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Room from "../../../domain/restaurant/Room";
import Table from "@/domain/restaurant/Table";

@Component
export default class TablePicker extends Vue {
  @Prop({ default: () => null })
  selectedRoom!: Room | null;

  @Prop({ default: () => "" })
  label!: string;

  @Prop({ default: () => null })
  defaultTableId!: number | null;

  tableId: number | null = this.defaultTableId;

  @Prop({ default: () => null })
  tableList!: Table[] | null;

  @Prop({ default: false })
  clearable!: boolean;

  @Prop({
    default: () => {
      return { colour: "", icon: "" };
    }
  })
  icon!: { colour: string; icon: string };

  @Prop({ default: false })
  loading!: boolean;

  tableColour(table: Table) {
    if (table != null) return Table.getTableAvailabilityColour(table);
    return "";
  }

  get tables() {
    if (this.selectedRoom != null) {
      this.selectedRoom.tables.sort(Table.TablesByNameAscendingComparator);
      return this.selectedRoom.tables;
    } else if (this.tableList != null) return this.tableList;
    return [];
  }

  get tableIsSelected(): boolean {
    return this.tableId != null;
  }

  @Watch("selectedRoom")
  @Watch("tableList")
  resetTable() {
    this.tableId = null;
  }

  @Watch("tableId")
  emitSelectedTable() {
    if (this.tableId == null || this.tableId !== this.defaultTableId) {
      this.$emit("table-selected", this.tableId);
    }
  }

  @Watch("defaultTableId")
  updateTableId() {
    this.tableId = this.defaultTableId;
  }

  clear() {
    this.tableId = null;
    this.$emit("clear");
  }
}
